import { filterTypes } from '../../config';

const SpecialsToggle = ({ handleChange, selectedFilters, deviceType = 'desktop' }) => {
    const toggleId = `specials-toggle-${deviceType}`;

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleChange({ value: 'specials' }, filterTypes.category);
        }
    };

    return (
        <div className="specials-toggle-wrapper">
            <label 
                className="toggle-switch-label" 
                htmlFor={toggleId}
            >
                <span className="toggle-label-text">Show deals</span>
                <div className="headless-toggle-box">
                    <input
                        className="tgl tgl-ios"
                        id={toggleId}
                        type="checkbox"
                        value="specials"
                        checked={Boolean(selectedFilters.specials)}
                        onChange={(e) => handleChange(e.target, filterTypes.category)}
                        onKeyPress={handleKeyPress}
                    />
                    <span 
                        className="tgl-btn"
                        aria-hidden="true"
                    />
                </div>
            </label>
        </div>
    );
};

export default SpecialsToggle;
